import {SEOManager} from "../../utilities/SEOManager";
import {Navbar} from "../../components/NavBar";
import Footer from "../../sections/Footer/Footer";
import React from "react";
import {Container} from "../../components/LayoutHelpers";

export default function PoliticaPrivacidad() {
    return (
        <div id="inicio" className="page">
            <SEOManager/>
            <Navbar/>

            <main id="content">
                <section id="servicios" className="section-alt">
                    <Container>
                        <h2 className="h2">{"Politica Privacidad"}</h2>
                        <h3>{"1. Responsable del tratamiento"}</h3>
                        <p>{"Identidad: Xavier Collado Sanchez"}</p>
                        <p>{"NIF: [NIF]"}</p>
                        <p>{"Domicilio: Barcelona"}</p>
                        <p>{"Correo electrónico: info@compassia.es"}</p>
                        <br/>

                        <h3>{"2. Finalidad del tratamiento"}</h3>
                        <p>{"Los datos personales que el usuario facilite a través del formulario de contacto de este sitio web serán tratados con la finalidad de responder a su solicitud o consulta."}</p>
                        <br/>

                        <h3>{"3. Legitimación"}</h3>
                        <p>{"La base legal para el tratamiento de sus datos es el consentimiento expreso otorgado por el usuario al marcar la casilla de aceptación antes de enviar el formulario."}</p>
                        <br/>

                        <h3>{"4. Conservación"}</h3>
                        <p>{"Los datos se conservarán únicamente durante el tiempo necesario para atender la consulta o solicitud planteada y, en su caso, el tiempo necesario para cumplir obligaciones legales."}</p>
                        <br/>

                        <h3>{"5. Destinatarios"}</h3>
                        <p>{"No se cederán datos a terceros, salvo obligación legal."}</p>
                        <br/>

                        <h3>{"6. Derechos del usuario"}</h3>
                        <p>{"El usuario tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos reconocidos en la normativa, que podrá ejercer enviando una solicitud a info@compassia.es"}</p>
                        <br/>

                        <p>{"Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si considera que se ha vulnerado la normativa sobre protección de datos."}</p>
                        <br/>

                    </Container>
                </section>

            </main>

            <Footer/>
        </div>
    );
}